import { isNullOrUndefined } from '@as-react/common-utils';
import { all, put, takeLatest } from 'redux-saga/effects';
import { ProductActionTypes, ProductPreviewActionTypes } from '../../../enums/ActionEnums';
import LocalStorageUtil from '../../../util/LocalStorageUtil';
import { productPreviewActions } from '../actions/ProductPreviewActions.creators';
const LOCAL_STORAGE_IMAGE_TOUCH_ZOOM_HINT_KEY = 'imageTouchZoomHint';
export function* loadImageTouchZoomHintFromLocalStorageSaga() {
    yield takeLatest(ProductActionTypes.INIT, loadImageTouchZoomHintFromLocalStorage);
}
export function* loadImageTouchZoomHintFromLocalStorage() {
    try {
        let imageTouchZoomHint = LocalStorageUtil.getJsonItem(LOCAL_STORAGE_IMAGE_TOUCH_ZOOM_HINT_KEY);
        if (isNullOrUndefined(imageTouchZoomHint)) {
            imageTouchZoomHint = true;
        }
        yield put(productPreviewActions.updateImageTouchZoomHint(imageTouchZoomHint));
    }
    catch (_a) { }
}
export function* disableImageTouchZoomHintSaga() {
    yield takeLatest(ProductPreviewActionTypes.DISABLE_IMAGE_TOUCH_ZOOM_HINT, disableImageTouchZoomHint);
}
export function* disableImageTouchZoomHint() {
    try {
        LocalStorageUtil.setItem(LOCAL_STORAGE_IMAGE_TOUCH_ZOOM_HINT_KEY, false);
        yield put(productPreviewActions.updateImageTouchZoomHint(false));
    }
    catch (_a) { }
}
export default function* productPreviewSaga() {
    yield all([loadImageTouchZoomHintFromLocalStorageSaga(), disableImageTouchZoomHintSaga()]);
}
